import { render, staticRenderFns } from "./theme-button.vue?vue&type=template&id=18a2f42c"
import script from "./theme-button.ts?vue&type=script&lang=js&external"
export * from "./theme-button.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports